import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import styled, { CSSObject } from 'styled-components';
import { MapPin } from '@hotelplan/components.common.map-pin';
import { agencyZIndex } from './fdr-agency-map.utils';
import { BsIcon } from '@hotelplan/core.basis.bs-icon';
import { FdrScheduleOpeningStatus } from 'components/candidate/fdr-schedule';
import { FdrAgencyFragment } from 'schemas/fragment/agency/fdr-agency.generated';
import { pinContent } from 'components/domain/fdr-map';

export const FdrAgenciesMapWrapper = styled.div.attrs({
  'data-id': `agencies-map-wrapper`,
})(
  sx2CssThemeFn({
    position: 'relative',
    width: '100%',
    height: ['136vw', '607px'],
    '.gm-bundled-control-on-bottom': {
      display: ['none', 'block'],
    },
    '.gmnoprint:last-child': {
      top: ['auto !important', 0],
      left: ['auto !important', 0],
      bottom: [0, 'auto'],
      right: [0, 'auto'],
      zoom: ['0.9', 'auto'],
    },
    '.agency-cluster': {
      ...pinContent,
      '.map-pin-content': {
        ...(pinContent['.map-pin-content'] as CSSObject),
        bottom: '-15px',
      },
    },
  }),
  () => ({
    '.gm-style-iw-c': {
      position: 'absolute',
      top: '-130px',
      transform: 'translateX(-50%)',
      maxHeight: 'unset !important',
      maxWidth: 'unset !important',
    },
    '.gm-style-iw-d': {
      maxHeight: 'unset !important',
      overflow: 'unset !important',
    },
    '.gm-ui-hover-effect': {
      display: 'none !important',
    },
  })
);

export const ClusterText = styled.span(
  sx2CssThemeFn({
    fontWeight: 'bold',
    position: 'absolute',
    fontSize: '10px',
    top: '53%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    color: 'white',
  })
);

export const MapCluster = styled.div({
  position: 'relative',
  width: '40px',
  height: '40px',
});

export const FdrAgencyMapPin = styled(MapPin)(
  () => pinContent,
  ({ object }) => agencyZIndex(object as FdrAgencyFragment)
);

export const FdrAgencyPinIconWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const FdrAgencyIconBlock = styled.div(
  sx2CssThemeFn({
    position: 'relative',
    color: 'redWeb',
  })
);

export const FdrAgencyIcon = styled(BsIcon)({
  position: 'absolute',
  top: '5px',
  left: '50%',
  transform: 'translateX(-50%)',
  color: 'white',
});

export const InfoSectionWrapper = styled.div(
  sx2CssThemeFn({
    bg: 'white',
    color: 'fontColor',
    p: '10px',
    mb: -5,
    zIndex: 2,
    fontSize: 1,
    borderRadius: '10px',
    boxShadow: 'cardShadow',
    cursor: 'pointer',
  })
);

export const InfoSectionHeader = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingRight: '20px',
});

export const FdrAgencyTitle = styled.span(
  ({ theme: { space, media, fontSizes } }) => ({
    whiteSpace: 'nowrap',
    fontWeight: 700,
    marginRight: space[4],
    fontSize: fontSizes[1],
    maxWidth: '200px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [media.tablet]: {
      marginRight: space[6],
      maxWidth: 'unset',
      textOverflow: 'unset',
      overflow: 'unset',
    },
  })
);

const middleDotDelimiter: CSSObject = {
  display: 'inline-block',
  content: `"\\00B7"`,
  width: '10px',
  height: '10px',
  marginLeft: '5px',
};

export const FdrAgencyAddress = styled.div(
  sx2CssThemeFn({
    whiteSpace: 'nowrap',
    '.address': {
      fontSize: '12px',
      '&:not(:last-child)': {
        '&:after': middleDotDelimiter,
      },
    },
  })
);

export const FdrAgencySchedule = styled.div({
  lineHeight: 1,
  fontSize: '12px',
});

export const FdrAgencyMapOpeningStatus = styled(FdrScheduleOpeningStatus)(
  ({ opened, theme: { colors } }) => ({
    color: opened ? colors.success : colors.error,
    display: 'inline-block',
    '&:after': opened ? middleDotDelimiter : {},
  })
);

export const DetailSectionTitle = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

export const CloseBtn = styled(BsIcon)({
  position: 'absolute',
  top: '20px',
  right: '10px',
  width: '15px',
  height: '15px',
});

export const FdrAgencyRating = styled.div(
  ({ theme: { fontSizes, space, colors } }) => ({
    display: 'flex',
    alignItems: 'center',
    marginTop: space[1],
    lineHeight: 1,
    '.rating': {
      fontSize: fontSizes[0],
    },
    '.average': {
      marginRight: '5px',
    },
    '.count': {
      marginLeft: '3px',
    },
    '.stars': {
      color: colors.redWeb,
    },
  })
);

export const RatingIcon = styled(BsIcon)(({ theme: { icons } }) => ({
  ...icons.xs,
  marginRight: '2px',
}));

export const InfoIconsWrapper = styled.div({
  display: 'flex',
  '.web-icon': {
    marginLeft: '20px',
  },
});

export const DetailIconBlock = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '.icon-text': {
    fontSize: '10px',
    marginTop: '2px',
    whiteSpace: 'nowrap',
  },
});

export const DetailIcon = styled(BsIcon)(({ theme: { colors } }) => ({
  width: '36px',
  height: '36px',
  color: colors.redWeb,
}));
